import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PoWidgetModule, PoTagModule, PoTagType } from '@po-ui/ng-components';
import { OrderModel } from '../../../../models/order.model';
import { CONSTANTS } from '../../../../constants';

@Component({
  selector: 'app-order-header-list',
  imports: [PoWidgetModule, PoTagModule, CommonModule],
  templateUrl: './order-header-list.component.html',
  styleUrl: './order-header-list.component.css'
})
export class OrderHeaderListComponent {
  @Input() orders: OrderModel[] | undefined;
  @Output() orderSelected = new EventEmitter<OrderModel>();
  statusLabels = CONSTANTS.ORDER_STATUS;
  colorsStatusLabels = CONSTANTS.ORDER_STATUS_COLORS;

  onClickOrder(item: OrderModel) {
    this.orderSelected.emit(item);
  }

  getStatusColor(value: number): PoTagType {
    return CONSTANTS.ORDER_STATUS_COLORS[value as keyof typeof CONSTANTS.ORDER_STATUS_COLORS] ?? PoTagType.Neutral;
  }


  getStatusLabel(value: number): string {
    return CONSTANTS.ORDER_STATUS[value as keyof typeof CONSTANTS.ORDER_STATUS] ?? '';
  }
}
